import { DELETE_PERMISSION_BY_REF } from "../constants";
import { getLocalStorage } from "../utils";

export interface DeletePermissionByRefRequest {
  docReference: string;
}

export const deletePermissionByRef = async (deleteRequest: DeletePermissionByRefRequest): Promise<any> => {
  try {
    const deletePermissionResponse = await fetch(DELETE_PERMISSION_BY_REF, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getLocalStorage("id-token")}`,
      },
      body: JSON.stringify(deleteRequest),
    });
    const deleteResponseContent = await deletePermissionResponse.json();

    return deleteResponseContent.data.message === "Success";
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("error", error);
  }

  return false;
};
